import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import ApiConfig from 'src/config/api-config';
import { FinalProgrammePlan } from 'src/screens/OnboardingTrainer/screens/Dashboard/screens/ProgramGenerated/types';

export interface SaveClientProgramPayload {
  clientId: string;
  trainerId?: string;
  programId?: string;
  plan: FinalProgrammePlan;
}

export const useSaveClientProgram = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: SaveClientProgramPayload) => {
      const response = await axios.post(
        `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_SAVE_PROGRAMME_PLAN}`,
        { data: payload },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['trainer-program-plan-list'] });
      queryClient.invalidateQueries({ queryKey: ['clientWorkoutsTab'] });
      queryClient.invalidateQueries({ queryKey: ['clientProgramTab'] });
      queryClient.invalidateQueries({ queryKey: ['clientOverview'] });
      queryClient.invalidateQueries({ queryKey: ['overview'] });
      queryClient.invalidateQueries({ queryKey: ['trainer_get_client_overview'] });
      queryClient.removeQueries({ queryKey: ['clientWorkoutsTab'] });
      queryClient.removeQueries({ queryKey: ['clientProgramTab'] });
      queryClient.removeQueries({ queryKey: ['clientOverview'] });
    },
  });
};
